// switch event color
export const dotColor = taskType => {
  switch (taskType) {
    case "reboot":
      return "#ff9e40";
    case "shutdown":
      return "#6d7278";
    case "start":
      return "#1DBBD4";
    case "wake_up":
    case "open_screen":
      return "#1DBBD4";
    case "sleep":
    case "close_screen":
      return "#6d7278";
    default:
      return "#1DBBD4";
  }
};

export const deployStatusDotColor = status => {
  switch (status) {
    case "success":
      return "#4CAF50";
    case "failed":
      return "#ff0000";
    default:
      return "#ff9e40";
  }
};

export const executeStatusColor = status => {
  switch (status) {
    case "notStarted":
      return "#aaa";
    case "inProgress":
      return "#00afc6";
    case "completed":
      return "#4CAF50";
    case "failed":
      return "#ff0000";
    default:
      return "#ff9e40";
  }
};

export const dotColorType = title => {
  switch (title) {
    case "reboot":
      return "#ff9e40";
    case "shutdown":
      return "#6d7278";
    case "start":
      return "#1DBBD4";
    case "wake_up":
    case "open_screen":
      return "#1DBBD4";
    case "sleep":
    case "close_screen":
      return "#6d7278";
    default:
      return "#1DBBD4";
  }
};

export const switchTitle = e => {
  switch (e) {
    case "start":
      return "Power On";
    case "shutdown":
      return "Power Off";
    case "reboot":
      return "Reboot";
    case "sleep":
    case "close_screen":
      return "Sleep";
    case "wake_up":
    case "open_screen":
      return "Wake Up";
    default:
      return e;
  }
};
export const switchBackTitle = e => {
  switch (e) {
    case "Power On":
      return "start";
    case "Power Off":
      return "shutdown";
    case "Reboot":
      return "reboot";
    case "Sleep":
      return "sleep";
    case "Wake Up":
      return "wake_up";
    default:
      return e;
  }
};
